import { BudgetRequestModel } from './BudgetRequest'

export class InsertionOrderBudgetModel {
  constructor(data) {
    const {
      id,
      insertionOrderId,
      budget,
      startTime,
      endTime,
      campaignBudgets,
      latestRequest,
    } = data

    this.id = id
    this.insertionOrderId = insertionOrderId
    this.budget = budget
    this.startTime = startTime
    this.endTime = endTime
    this.campaignBudgets = campaignBudgets
    this.latestRequest = new BudgetRequestModel(latestRequest)
  }

  static assign(data) {
    return new InsertionOrderBudgetModel(data)
  }
}
